// Zaharlab 8-Stage Customer Journey Audit Data

export const ANSWER_OPTIONS = [
  { value: 1, label: "Strongly Disagree" },
  { value: 2, label: "Disagree" },
  { value: 3, label: "Neutral" },
  { value: 4, label: "Agree" },
  { value: 5, label: "Strongly Agree" }
];

export const BUSINESS_TYPES = [
  { value: "service", label: "Service Business" },
  { value: "ecommerce", label: "E-commerce" },
  { value: "startup", label: "Startup (pre-revenue)" }
];

export const REVENUE_RANGES = [
  { value: "under-15k", label: "Under $15,000" },
  { value: "15k-50k", label: "$15,000 - $50,000" },
  { value: "50k-plus", label: "$50,000+" }
];

export const STAGES = [
  {
    number: 1,
    name: "Awareness",
    definition: "Can the right audience immediately recognize your business is for them?",
    statements: [
      "Our messaging clearly defines who we serve and who we don't.",
      "We communicate specific outcomes, not just services.",
      "Our positioning differentiates us within 10 seconds.",
      "We attract qualified leads, not just traffic."
    ]
  },
  {
    number: 2,
    name: "Attention / Engagement",
    definition: "Do you capture and hold attention effectively?",
    statements: [
      "Our hooks address painful problems directly.",
      "Our content stops the scroll.",
      "We create urgency or tension in our messaging.",
      "Prospects engage meaningfully with our content."
    ]
  },
  {
    number: 3,
    name: "Subscription / Lead Capture",
    definition: "Do you convert attention into owned audience?",
    statements: [
      "We have clear lead magnets or entry offers.",
      "Our funnel captures leads consistently.",
      "Follow-up sequences are automated.",
      "Lead capture rates are measurable."
    ]
  },
  {
    number: 4,
    name: "Conversion",
    definition: "Can you predictably turn prospects into clients?",
    statements: [
      "Our offer is outcome-driven and clear.",
      "Our pricing is positioned confidently.",
      "Our sales process is structured.",
      "We track close rates."
    ]
  },
  {
    number: 5,
    name: "Onboarding",
    definition: "Does the first 30 days build trust and momentum?",
    statements: [
      "Onboarding is structured and clear.",
      "Expectations are aligned early.",
      "Clients feel confident quickly.",
      "We minimize early churn."
    ]
  },
  {
    number: 6,
    name: "Core Offer Delivery",
    definition: "Is your delivery system scalable and measurable?",
    statements: [
      "We have repeatable processes.",
      "Results are tracked with data.",
      "Client communication is proactive.",
      "Delivery quality is consistent."
    ]
  },
  {
    number: 7,
    name: "Retention",
    definition: "Do clients stay and expand?",
    statements: [
      "We track client lifetime value.",
      "We proactively upsell or expand services.",
      "We conduct performance reviews.",
      "Clients stay beyond initial contract terms."
    ]
  },
  {
    number: 8,
    name: "Advocacy / Promoter",
    definition: "Do clients actively refer and promote you?",
    statements: [
      "We request testimonials strategically.",
      "We have a referral system.",
      "Clients introduce us to others.",
      "We leverage case studies publicly."
    ]
  }
];

export const EVALUATION_TIERS = {
  OPTIMIZED: {
    name: "Optimized & Scalable",
    minScore: 130,
    description: "Your customer journey demonstrates operational excellence. Each stage functions with precision, creating a self-reinforcing growth engine. Focus now on optimization, automation, and scaling what already works."
  },
  GROWTH_LEAKS: {
    name: "Growth Leaks Detected",
    minScore: 100,
    description: "Your foundation is solid, but revenue is escaping through specific gaps in your customer journey. Strategic intervention at your weak points could unlock significant additional revenue without acquiring new traffic."
  },
  STRUCTURAL: {
    name: "Structural Weakness",
    minScore: 70,
    description: "Multiple stages of your customer journey require attention. Growth efforts are being undermined by systemic issues that compound at each stage. Prioritized restructuring is recommended before scaling."
  },
  UNSTABLE: {
    name: "Unstable Growth Foundation",
    minScore: 0,
    description: "Your customer journey lacks the fundamental systems required for sustainable growth. Immediate strategic intervention is necessary to establish baseline operational capacity before pursuing growth initiatives."
  }
};

export const getTierForScore = (score) => {
  if (score >= 130) return EVALUATION_TIERS.OPTIMIZED;
  if (score >= 100) return EVALUATION_TIERS.GROWTH_LEAKS;
  if (score >= 70) return EVALUATION_TIERS.STRUCTURAL;
  return EVALUATION_TIERS.UNSTABLE;
};

export const getWeakestStages = (stageScores, count = 2) => {
  return [...stageScores]
    .sort((a, b) => (a.score / a.maxScore) - (b.score / b.maxScore))
    .slice(0, count)
    .map(s => s.stageName);
};

export const CALENDAR_LINK = "https://api.leadconnectorhq.com/widget/booking/2Sa395sv0O6JZE7GBfpf";

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_stage-audit-platform/artifacts/8y906124_ChatGPT%20Image%20Jan%2023%2C%202026%20at%2012_25_42%20PM.png";
